export const SESSIONS_TABLE_SETTINGS = {};

export const PAGINATION_CONFIG = {
  START_PAGE: 0,
  ITEMS_PER_PAGE: 20
};

export const WTC_EXCLUDED_VALIDATION_ERRORS_NO_MOTOR_BOAT = [
  'wtcBoatArea',
  'wtcBoatRental',
  'wtcBoatTracker',
  'wtcBoatYoungUser',
  'wtcBoatSecuremark',
  'wtcBoatWinterStorage',
  'wtcBoatHarborSecurity'
];

export const WTC_EXCLUDED_VALIDATION_ERRORS_SAILBOAT = [
  'wtcBoatSecuremark'
];
